import { render, staticRenderFns } from "./FavoriteChallenges.vue?vue&type=template&id=4692ee06&"
import script from "./FavoriteChallenges.vue?vue&type=script&lang=js&"
export * from "./FavoriteChallenges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports